module.exports = __webpack_public_path__ + "static/img/123.616e062.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/123.png
// module id = ALGL
// module chunks = 2